<template>
  <div class="modal" data-backdrop="static" id="bsProjectTemplateSaveFormDialog" ref="bsProjectTemplateSaveFormDialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content viewDetails">
        <form name="saveProjectTemplate"
              :action="pUrls['saveProjectTemplate']"
              method="post" class="ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#projectTemplateListHeader,#projectTemplateListBody,#projectTemplateViewBody">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body max-height bs3-padding-top-reset bs3-padding-bottom-reset">

            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="bs3-padding-y">
              <!--
               - NAME
               --->
              <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.name')}]">
                <div v-if="hasFieldErrors('dataForm.data.name')">
                  <span v-for="error in getFieldErrors('dataForm.data.name')" class="help-block" :key="error">{{ error }}</span>
                </div>
                <label v-else for="projectTemplate_Name">
                  <span class="required">*</span> {{ pDictionary['dictionary.project.template.name'] }}
                </label>
                <input type="text"
                       id="projectTemplate_Name"
                       :name="'dataForm.data.name'"
                       v-model="data.name"
                       class="form-control"
                       :placeholder="pDictionary['dictionary.project.template.name.placeholder']"/>
              </div>

              <project-template-save-form-task-rule-section
                  :p-dictionary="pDictionary"
                  :p-error-list="pErrorList"
                  :p-currencies="pCurrencies"
                  :p-language="pLanguage"
                  :p-task-rules="data.taskRules"
                  @add-task-rule="onAddTaskRule"
                  @copy-task-rule="onCopyTaskRule"
                  @remove-task-rule="onRemoveTaskRule">
              </project-template-save-form-task-rule-section>
            </div>

          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import ProjectTemplateSaveFormTaskRuleSection from "@/components/modules/production-module/project-template/form-save/ProjectTemplateSaveFormTaskRuleSection";

export default {
  name: "ProjectTemplateSaveForm",
  components: {ProjectTemplateSaveFormTaskRuleSection},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      errorList: [],
      newTaskCounter: 1
    }
  },
  methods: {
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    },
    onAddTaskRule: function () {
      var _component = this;
      $.ajax({
               type: "GET",
               url: "/mediaplan/app/endpoints/json-api/project-templates/task-rules/new",
               data: {
               },
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        data.id = -(_component.newTaskCounter++);
        _component.data.taskRules.push(data);
        _component.errorList.push({});
      });
    },
    onCopyTaskRule: function(taskRule) {
      var newTaskRule = JSON.parse(JSON.stringify(taskRule));
      newTaskRule.id = null;
      let newTaskRuleName = "";
      if(newTaskRule.name !== null)
      {
        newTaskRuleName += newTaskRule.name + " ";
      }
      newTaskRule.name = newTaskRuleName  + (this.pLanguage === 'fr' ? "Copie" : "Copy");
      this.data.taskRules.push(newTaskRule);
      this.errorList.push({});
    },
    onRemoveTaskRule: function (taskRule) {
      let index = this.data.taskRules.indexOf(taskRule);
      this.data.taskRules.splice(index, 1);
    }
  },
  computed: {
    title: function () {
      return this.isIdValid()
             ? this.pDictionary['dictionary.project.template.udate.title']
             : this.pDictionary['dictionary.project.template.create.title'];
    }
  },
  mounted: function () {
    let _component = this;

    let $bsProjectTemplateSaveFormDialog = $(this.$refs.bsProjectTemplateSaveFormDialog);
    $bsProjectTemplateSaveFormDialog.on('shown.bs.modal', function () {

    });

    $bsProjectTemplateSaveFormDialog.on('hidden.bs.modal', function () {

    });

    $(_component.$refs.bsProjectTemplateSaveFormDialog).modal();
  }
}
</script>

<style scoped>

</style>